/* global SideDrawer */
if (!customElements.get('warranty-drawer')) {
  class WarrantyDrawer extends SideDrawer {
    constructor() {
      super();
      this.warranties = JSON.parse(this.querySelector('#warranties-data')?.innerText || '[]');
      if(!this.warranties.length) return;

      this.quantity = 0;
      this.mainProductSku = null;
      this.expectedProductId;

      this.content = this.querySelector('.drawer__warranty-content-items');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.closeBtn = this.querySelector('.js-close-drawer');

      document.addEventListener('rebuy:cart.add', (event)=>{
        const item = event.detail.item;
        const matchingProduct = window.ProductsWithWarranty?.find(product=>product.id == item.product_id && product.price);
        if(matchingProduct) {
          this.quantity = item.quantity;
          this.mainProductSku = item.sku;
  
          this.handleAddMainProduct(matchingProduct.price);
        }
      });
    }

    handleAddMainProduct(price) {
      const warrantiesList = this.buildWarrantyOptions(price);
      if(warrantiesList) {
        this.open();
      }
    }
    
    handleAddWarrantyProduct(evt) {
      const warrantyVariantId = evt.currentTarget.dataset.warrantyVariantId;
			const cartDrawer = document.querySelector('cart-drawer');

			let sections = 'cart-icon-bubble';
			if (cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
			}

      const data = {
        items: [
          {
            id: warrantyVariantId,
            quantity: this.quantity,
            properties: {
              '_warranty_for': this.mainProductSku,
            },
          },
        ],
        sections: sections,
      };

			fetch(`${theme.routes.cartAdd}.js`, {
				method: 'POST',
				body: JSON.stringify(data),
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.catch(function (error) {
					console.log(error);
				}).finally(()=>{
          this.closeBtn?.click();
        })
		}

    buildWarrantyOptions(price) {
      this.content.innerText = '';

      let warrantiesList = '';
      this.warranties.forEach(warranty=>{
        if(Number(price) >= Number(warranty.price_from) && Number(price) <= Number(warranty.price_to)) {
          const warrantyPrice = warranty.product_price / 100;
          const formattedWarrantyPrice = warrantyPrice ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(warrantyPrice) : null;
          
          if(!(warranty.product_variant_id && warranty.product_name && formattedWarrantyPrice)) return;

          warrantiesList += `<div class="warranty-option">
            <div class="warranty-option__content">
                <a href="/products/${warranty.product_handle}" class="warranty-option__title">${warranty.product_name}</a>
                <span class="warranty-option__price">${formattedWarrantyPrice}</span>
              </div>
              <div class="warranty-option__button">
                <button type="button" class="btn warranty-option-btn" data-warranty-variant-id="${warranty.product_variant_id}">
                  ${theme.strings.warranty.add_to_order}
                </button>
              </div>
            </div>`
        }
      });

      this.content.innerHTML = warrantiesList;
      this.warrantyOptionBtn = this.content.querySelectorAll('.warranty-option-btn');

      this.warrantyOptionBtn.forEach(btn => {
        btn.addEventListener('click', this.handleAddWarrantyProduct.bind(this));
      });

      return warrantiesList;
    }
  }

  customElements.define('warranty-drawer', WarrantyDrawer);
}
